"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var icon_1 = __importDefault(require("../../icon"));
function PackageSwitchMobile(props) {
    var _a = props.configuration, configuration = _a === void 0 ? [] : _a;
    var _b = (0, react_1.useState)(0), active = _b[0], setActive = _b[1];
    var _c = (0, react_1.useState)(configuration[0]), currentConfig = _c[0], setCurrentConfig = _c[1];
    // 默认进入页面的主题色渲染
    var themeClass = (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme) ? "".concat(currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.colorTheme, "-theme") : '';
    /**
     * 渲染移动端产品列表
     */
    function renderTabItem(item, index) {
        var txt = item.txt, tabExtendProps = item.tabExtendProps;
        return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)('item-tab-item-mo', themeClass, {
                'is-active': active === index,
            }), onClick: function () {
                setActive(index);
                setCurrentConfig(configuration[index]);
            } }, (tabExtendProps || {}), { key: index }),
            react_1.default.createElement("div", { className: "item-tab-item-txt-mo" }, txt)));
    }
    /**
     * 渲染移动端tab列表
     */
    function renderTabList() {
        return react_1.default.createElement("div", { className: "item-tab-list-mobile" }, configuration === null || configuration === void 0 ? void 0 : configuration.map(renderTabItem));
    }
    /**
     * 渲染移动端描述item
     */
    function rendeDescItem(item, index) {
        var desc = item.desc, isIcon = item.isIcon;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)('item-desc-item-mobile', themeClass), key: index },
            isIcon ? (react_1.default.createElement(icon_1.default, { name: "check", size: 18, color: themeClass ? '#ff6b00' : '#006eff', className: "desc-icon" })) : null,
            react_1.default.createElement("div", { className: "item-desc-item-content-mobile" }, desc)));
    }
    /**
     * 渲染移动端描述列表
     */
    function rendeDescList() {
        var _a;
        return (react_1.default.createElement("div", { className: "item-desc-list-mobile" }, (_a = currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.descList) === null || _a === void 0 ? void 0 : _a.map(rendeDescItem)));
    }
    /**
     * 渲染移动端按钮模块
     */
    function renderBtn() {
        return (react_1.default.createElement("div", { className: "item-btn-mobile" },
            react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)('item-btn-txt-mobile', themeClass), onClick: function () {
                    (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.onCallback) && (currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.onCallback());
                } }, ((currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.extendProps) || {})), currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.btnTxt)));
    }
    return (react_1.default.createElement("div", { className: "package-switch-wrap-mobile" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('item-title-mobile', themeClass) }, currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.rightTitle),
        react_1.default.createElement("div", { className: "item-desc-mobile" }, currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.rightDesc),
        renderTabList(),
        rendeDescList(),
        renderBtn()));
}
exports.default = PackageSwitchMobile;
//# sourceMappingURL=PackageSwitchMobile.js.map